import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Capture the PWA install prompt globally so the UI can trigger it later.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__wadoDeferredPrompt = e;
  window.dispatchEvent(new Event("wado-can-install"));
});
window.addEventListener("appinstalled", () => {
  window.__wadoDeferredPrompt = null;
  window.dispatchEvent(new Event("wado-installed"));
});
